<template>
  <div>
    <b-card v-if="isCard">
      <vue-apex-charts
        v-if="series.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
    <div v-else>
      <vue-apex-charts
        v-if="series.length"
        type="line"
        height="450"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'MixedCharts',
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
    yaxisData: {
      type: Array,
      required: true,
    },
    suffix: {
      type: String,
      default: 'adet',
    },
  },
  data() {
    return {
      series: [],
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 450,
          type: 'line',
          stacked: false,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 4],
        },
        title: {
          text: '',
          align: 'left',
          offsetX: 0,
        },
        xaxis: {
          categories: [],
        },
        yaxis: [],
        tooltip: {
          fixed: {
            enabled: false,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
          y: {
            formatter(value, { seriesIndex }) {
              if (seriesIndex === 2) {
                return `% ${Math.round(value)}`
              }
              return `${Math.round(value)} adet`
            },
          },
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40,
        },
      }
    },
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    titleText: 'setData',
    yaxisData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.chartOptions.title.text = this.titleText
      this.chartOptions.yaxis = this.yaxisData
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
